import { render, staticRenderFns } from "./markUp.vue?vue&type=template&id=2f675f4a&scoped=true"
import script from "./markUp.vue?vue&type=script&lang=js"
export * from "./markUp.vue?vue&type=script&lang=js"
import style0 from "./markUp.vue?vue&type=style&index=0&id=2f675f4a&prod&scoped=true&lang=less"
import style1 from "./markUp.vue?vue&type=style&index=1&id=2f675f4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f675f4a",
  null
  
)

export default component.exports